import date from './extra-dates.store'
import {extraService} from "../../network/services/extras.service";
import {ResponseError} from "../../network/response/response-error";

export default {
  namespaced: true,
  state: {
    extras: [],
    categories: [],
    edge_by_room: [],
    loading: false
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = !!payload;
    },
    SET_EXTRAS(state, payload) {
      state.extras = payload;
    },
    SET_CATEGORIES(state, payload) {
      state.categories = payload;
    },
    SET_EDGE_BY_ROOM (state, payload) {
      state.edge_by_room = payload;
    }
  },
  actions: {
    async fetch (context, {room_id, lang}) {
      context.commit('SET_LOADING', true);
      const response = await extraService.step3ExtraList({room_id, lang});
      const extras = response.get('Extras.many', []);
      const categories = response.get('ExtraCategory.many', []);
      const extraByRoom = response.get('Extras.edge_by_room', []);
      if (extras instanceof ResponseError) {
        // TODO catch errors
      } else {
        context.commit('SET_EXTRAS', extras);
      }
      if (categories instanceof ResponseError) {
        // TODO catch errors
      } else {
        context.commit('SET_CATEGORIES', categories);
      }
      if (extraByRoom instanceof ResponseError) {
        // TODO catch errors
      } else {
        context.commit('SET_EDGE_BY_ROOM', extraByRoom);
      }
      context.commit('SET_LOADING', false);
    }
  },
  modules: {date}
}



// WEBPACK FOOTER //
// ./src/stores/shopping-cart/extras.store.js